import { useEffect } from 'react'

const FullScreen = ({ handle, onChange, children, className }) => {
    const classNames = []
    if (className) {
        classNames.push(className)
    }

    classNames.push('fullscreen')

    if (handle.active) {
        classNames.push('fullscreen-enabled')
    }

    useEffect(() => {
        if (onChange) {
            onChange(handle.active, handle)
        }
    }, [handle.active])

    return (
        <div
            className={classNames.join(' ')}
            ref={handle.node}
            style={handle.active ? { height: '100%', width: '100%' } : undefined}
        >
            {children}
        </div>
    )
}

export default FullScreen
